export const MainMenuLocalization = {
  SavedCarts: $localize`:@@menu.carts.heading.saved-carts:Saved Carts`,
  SavedPartLists: $localize`:@@menu.part-lists.heading.saved-part-lists:Part Lists`,
} as const;
